import { render, staticRenderFns } from "./TeacherApprovalDetails.vue?vue&type=template&id=4aaf6dae&scoped=true"
import script from "./TeacherApprovalDetails.vue?vue&type=script&lang=js"
export * from "./TeacherApprovalDetails.vue?vue&type=script&lang=js"
import style0 from "./TeacherApprovalDetails.vue?vue&type=style&index=0&id=4aaf6dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf6dae",
  null
  
)

export default component.exports